<template>
  <v-content>
    <form action="">
      <v-text-field v-model="searchFieldValue" @input="searchSuggestion" label="skriv søkenavn"></v-text-field>
      <v-btn type="submit" @click="searchSuggestion"></v-btn>
    </form>
    <pre>
      {{ resultJSON }}
    </pre>
  </v-content>
</template>


<script>
export default {
  data() {
    return {
      searchFieldValue: '',
      resultJSON: null
    }
  },
  methods: {
    searchSuggestion() {
      this.axios.get('/geo/suggestion?name='+this.searchFieldValue).then(res => {this.resultJSON = res}).catch(ex => {console.log("ex", ex)})
    }
  }
};
</script>

<style scoped>
.topbar-breakingnews {
  margin-top: 20px;
  border: 4px solid #000000;
}
.breakingnews.label {
  background-color: #000000;
  color: #ffffff;
  padding: 1px 20px;
}
.breakingnews.blackarrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #000000;
}

.breakingnews.whitearrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 0 3.5px 7px;
  border-color: transparent transparent transparent #ffffff;
}
.breakingnews.readmore {
  background-color: #000000;
  color: #ffffff;
  padding: 1px 20px;
}
.topbar-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: flex-start;
}
.topbar-container > * {
  /* outline: 1px solid black; */
  width: 100%;
}

.topbar-container .left {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: left;
}

.topbar-container .center {
  order: 0;
  flex: 0 2 auto;
  align-self: auto;
}
.topbar-container .center img {
  width: 150px;
}

.topbar-container .right {
  margin: 15px;
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  text-align: right;
}
.topbar-container .right a {
  text-decoration: none;
  color: black;
}
.topbar-container .right a:hover {
  text-decoration: underline;
}
.topbar-menu-container {
  border-bottom: 4px solid black;
  padding-bottom: 20px;
}
.topbar-menu-container .flex {
  text-align: center;
}
</style>
